import React from "react";
import AdvancedTable from "components/LM/common/AdvancedTable";
import K2Api from "lib/ajax/K2Api";
import DateFormat from "components/LM/common/DateFormat";
import FormDatesSearch from "components/LM/common/FormDatesSearch";

const TABLE_COLUMNS = [
  {
    name: "publication_date",
    alias: "Date"
  },
  {
    name: "title",
    alias: "Caption"
  },
  {
    name: "document_id",
    alias: "ID"
  },
];

function PostsDisplay(props) {
  const { profileId, type } = props;

  return (
    <AdvancedTable
      columns={TABLE_COLUMNS}
      onSearch={(params) => postsSearch(type, profileId, params)}
      onResults={processResponse}
    >
      <FormDatesSearch />
    </AdvancedTable>
  );
}

async function postsSearch(
  type,
  profileId,
  { beginDate, endDate, page, pageSize }
) {
  const from = (page - 1) * pageSize;
  const request = { beginDate, endDate, from, size: pageSize };

  const k2Api = new K2Api();
  const response = await k2Api.get(
    `/socialmedia/${type}/documents/${profileId}`,
    { params: request }
  );
  return response.data;
}

function processResponse(response) {
  const total = response.total;
  const rows = response.documents.map((row) => {
    const title = row.title || <i>No caption</i>;
    let title_url = row.url;
    if (row?.channel_type_id === 52) {
      title_url = `${process.env.REACT_APP_XIAOHONGSHU_PROXY_URL}${row.url}`;
    }

    return {
      ...row,
      id: row.id,
      document_id: (
        <a
          href={`${process.env.REACT_APP_ORANGETOOL_URL}/document/${row.id}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          {row.id}
        </a>
      ),
      title: (
        <a href={title_url} target="_blank" rel="noopener noreferrer">
          {title}
        </a>
      ),
      publication_date: <DateFormat>{row.publication_date}</DateFormat>,
    };
  });

  return { total, rows };
}

export default PostsDisplay;
